import {Component, OnInit, Type, ViewChild, ViewContainerRef} from '@angular/core';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';



import { AppModalService } from '../modal.service';

import { DynamicComponentLoader } from '../../base/dynamic-component-loader.service';
import { ProfileResetPasswordModalComponent } from '../../profile/profile-reset-password-modal/profile-reset-password-modal.component';
import { BrandChooseModalComponent } from '../../brand/brand-choose-modal/brand-choose-modal.component';
import { SimpleTableModalComponent } from '../../modal/simple-table-modal/simple-table-modal.component';
import { SimpleConfirmModalComponent } from '../../modal/simple-confirm-modal/simple-confirm-modal.component';
import { FitmentDuplicateModalComponent } from '../../modal/fitment-duplicate-modal/fitment-duplicate-modal.component';
import { ExportDownloadsModalComponent } from '../../modal/export-downloads-modal/export-downloads-modal.component';
import {
  RESET_PASSWORD_MODAL_NAME,
  BRAND_CHOOSE_MODAL_NAME,
  SIMPLE_TABLE_MODAL_NAME,
  SIMPLE_CONFIRM_MODAL_NAME,
  FITMENT_DUPLICATE_MODAL_NAME,
  EXPORT_DOWNLOADS_MODAL_NAME,
} from '../modal-names';
import { first, takeWhile } from 'rxjs/operators';

/**
 * This class represents the modal layout component.
 */
@Component({
  moduleId: module.id,
  selector: 'modal-layout',
  templateUrl: 'modal-layout.component.html',
  providers: [DynamicComponentLoader]
})
export class ModalLayoutComponent implements OnInit {
  subscription: any;

  @ViewChild('modalContainer', { read: ViewContainerRef, static: false })
  modalContainer: ViewContainerRef | void;

  constructor(
    protected modalService: AppModalService,
    private dynamicComponentLoader: DynamicComponentLoader,
  ) {}

  ngOnInit() {
    this.subscription = this.modalService.openModalListener
    .subscribe((modalData: any) => {
      if (modalData) {
        this.show(modalData);
      }
    });
  }

  // private
  private show(modalData: any) {
    this.modalService.activeModal = null;
    const component = this.getModalComponentByName(modalData.name);
    if (component) {
      let inputData: any = {};
      let outputData: any = {};
      if (modalData.inputData) { inputData = modalData.inputData; }
      if (modalData.outputData) { outputData = modalData.outputData; }
      const componentRef = this.dynamicComponentLoader.load(
        component,
        this.modalContainer,
        inputData,
        outputData,
      );
      this.modalService.activeModal = componentRef.instance;
      this.subscribeDestroyEvent();
      this.subscribeHiddenEvent();
      _.defer(() => componentRef.instance.show());
    }
  }

  private getModalComponentByName(modalName: string): Type<any>|null {
    switch (modalName) {
      case RESET_PASSWORD_MODAL_NAME:
        return ProfileResetPasswordModalComponent;
      case BRAND_CHOOSE_MODAL_NAME:
        return BrandChooseModalComponent;
      case SIMPLE_TABLE_MODAL_NAME:
        return SimpleTableModalComponent;
      case SIMPLE_CONFIRM_MODAL_NAME:
        return SimpleConfirmModalComponent;
      case FITMENT_DUPLICATE_MODAL_NAME:
        return FitmentDuplicateModalComponent;
      case EXPORT_DOWNLOADS_MODAL_NAME:
        return ExportDownloadsModalComponent;
      default:
        console.warn(`There is no modal named ${modalName}`);
        return null;
    }
  }

  private subscribeDestroyEvent() {
    if (this.modalService.activeModal.ngDestroyEvent) {
      this.modalService.activeModal.ngDestroyEvent
      .pipe(first(), takeWhile(() => !!this.modalService.activeModal))
      .subscribe(() => {
        this.modalService.activeModal = null;
      });
    }
  }

  private subscribeHiddenEvent() {
    if (this.modalService.activeModal.onHidden) {
      this.modalService.activeModal.onHidden
      .pipe(first(), takeWhile(() => !!this.modalService.activeModal))
      .subscribe(() => {
        this.dynamicComponentLoader.destroy();
        _.defer(() => this.modalService.activeModal = null);
      });
    }
  }
}
